module.exports = __webpack_public_path__ + "img/sort-numeric-down.1a18fd11.svg";